import { z } from "zod";

export const positiveIntegerSchema = z.number().int().positive();
export const stringArraySchema = z.array(z.string());

export const articleFiltersSchema = z.object({
  "articles:page": positiveIntegerSchema,
  "articles:categories": stringArraySchema,
});

export const filtersSchema = z.object({
  articles: articleFiltersSchema,
});

export type TArticleFilters = z.infer<typeof articleFiltersSchema>;
export type TFilters = z.infer<typeof filtersSchema>;
